
Number.prototype.formatMoney = function (c, d, t) {
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

const install = (VueInstance) => {

    VueInstance.filter('pessoaNome', function (pessoa) {

        if(typeof pessoa === 'undefined' || pessoa == null){
            return 'Não informado(a)'
        }

        if (pessoa.nome === '' || pessoa.nome == null) {
            return pessoa.razao_social + (pessoa.cnpj == null ? '' : ' - ' + pessoa.cnpj);
        }

        return pessoa.nome + (pessoa.cpf == null ? '' : ' - ' + pessoa.cpf);
    });

    VueInstance.filter('formatMoney', function (valor) {
        return parseFloat(valor).formatMoney(2, ',', '.');
    });

    VueInstance.filter('formatData', function (data) {
        if(data == null) {
            return '';
        }
        return data.split('-').reverse().join('/');
    });

};

export default {install};